import React, { useEffect, useState } from 'react';
import { getPayoutReleaseStatus } from '../utils/escrowDisplay';

/**
 * Payout status badge for the trade/purchase progress "Payout" row.
 * Pending (amber) → "Releases in Xh Ym" (rust) → Released (green).
 *
 * The pending→countdown and countdown→released transitions are doc writes
 * (delivery monitors / release monitors), and BOTH progress pages load their
 * doc with a one-shot getDoc, not onSnapshot — so those transitions appear on
 * page load, navigation back, or pull-to-refresh, exactly as they always have.
 * The countdown VALUE and the 24h-elapsed boundary, however, pass with no
 * write at all, so this badge re-renders itself once a minute while the
 * countdown is live — without that, a page left open showed a frozen
 * countdown that never reached "Releasing soon".
 */
const PayoutReleaseBadge = ({ transferStatus, deliveredAt }) => {
  const [, setTick] = useState(0);
  const status = getPayoutReleaseStatus(transferStatus, deliveredAt);

  useEffect(() => {
    if (status.state !== 'countdown') return undefined;
    const id = setInterval(() => setTick((t) => t + 1), 60 * 1000);
    return () => clearInterval(id);
  }, [status.state]);

  const tone =
    status.state === 'released' ? 'green' : status.state === 'countdown' ? 'rust' : 'amber';
  return <span className={`tp-badge tp-badge-${tone}`}>{status.label}</span>;
};

export default PayoutReleaseBadge;
